import PropTypes from 'prop-types';

export const IndividualPaymentOptionType = PropTypes.shape({
  loanMonth: PropTypes.number,
  interest: PropTypes.number,
  adminFee: PropTypes.number,
  monthlyRepaymentAmount: PropTypes.number,
  monthlyCost: PropTypes.number,
  effectiveInterest: PropTypes.number,
  totalLoanCost: PropTypes.number,
  arrangementFee: PropTypes.number,
  heading: PropTypes.string, // These seem to be ENUM like '36 MÅN'
  leastAmountToPay: PropTypes.number,
  subAccountType: PropTypes.string, // No idea what to have here was empty string from what i could find out
  creditCost: PropTypes.number,
  paymentUnit: PropTypes.string // These seem to be ENUM like 'M' might be of value to have
});

export const LinkType = PropTypes.shape({
  uri: PropTypes.string,
  linkText: PropTypes.string
});

export const IndividualPriceInformationType = PropTypes.shape({
  conciergeServiceFee: PropTypes.number,
  replacementCardFee: PropTypes.number,
  extraCardFee: PropTypes.number,
  reclamationFee: PropTypes.number,
  delayedPaymentFee: PropTypes.number,
  validToDate: PropTypes.string, // This string should be a valid Date,
  accountResearch: PropTypes.number,
  copyExtraStatement: PropTypes.number,
  billOfSaleCopy: PropTypes.number,
  periodicity: PropTypes.number,
  labWithdrawalForm: PropTypes.number,
  labWithdrawalFee: PropTypes.number,
  loungeKeyServiceFee: PropTypes.number,
  maxWithdrawalAmount: PropTypes.number,
  maxWithdrawalAmountPerWeek: PropTypes.number,
  messageServiceFee: PropTypes.number,
  keyTabServiceFee: PropTypes.number,
  emergencyTicketServiceFee: PropTypes.number,
  emergencyCashServiceFee: PropTypes.number,
  overdraftFee: PropTypes.number,
  reminderFee: PropTypes.number,
  withdrawalFormProc: PropTypes.number,
  withdrawalFeeProc: PropTypes.number,
  exchangeFeeProc: PropTypes.number,
  travelInsurance: PropTypes.number,
  cardBlockService: PropTypes.number,
  payoutInCreditFee: PropTypes.number,
  billPaymentFee: PropTypes.number,
  vacationService: PropTypes.number,
  annualFee: PropTypes.number,
  sekkiTemplateId: PropTypes.string,
  lowestPurchaseAmount: PropTypes.number,
  changeRequest: PropTypes.number,
  amountLimitArrangementFee: PropTypes.number,
  interestOnArrears: PropTypes.number,
  campaignFee: PropTypes.number,
  dailyPurchasingInterest: PropTypes.number,
  individualPaymentOption: PropTypes.arrayOf(IndividualPaymentOptionType)
});

export const CostOfPurchaseType = PropTypes.shape({
  errorInformation: PropTypes.string,
  beforeTableText: PropTypes.string,
  afterTableText: PropTypes.string,
  interestFreeText: PropTypes.string,
  monthText: PropTypes.string,
  creditAmountText: PropTypes.string,
  paymentOptionsText: PropTypes.string,
  termsText: PropTypes.string,
  interestText: PropTypes.string,
  administrationFeeText: PropTypes.string,
  feeText: PropTypes.string,
  effectiveInterestText: PropTypes.string,
  monthlyAmountText: PropTypes.string,
  creditCostText: PropTypes.string,
  totalAmountText: PropTypes.string,
  individualPriceInformation: IndividualPriceInformationType,
  sekkiLinks: PropTypes.arrayOf(LinkType),
  generalTermsLinks: PropTypes.arrayOf(LinkType),
  reservationTextRowOne: PropTypes.string,
  reservationTextRowTwo: PropTypes.string,
  sekkiText: PropTypes.string,
  generalTermsText: PropTypes.string,
  amountForPresentation: PropTypes.string // Is a number but casted to string
});
